import React, {Component} from 'react';

import './index.scss';

/**
 * MainIndex
 */
export class MainIndex extends Component { // eslint-disable-line react/prefer-stateless-function
  render() {
    return (
        <div className="main-message">
          Welcome to IdP Admin Service
        </div>
    );
  }
}

export default MainIndex;
